<template>
  <div class="page-bar">
    <ul class="page-breadcrumb">
      <li>
        <i class="icon-home"></i>
        <router-link to="/admin/dashboard">{{ (user.organizations[0] == null) ? 'CaseMGR' : user.organizations[0].name }}</router-link>
        <i class="fa fa-angle-right"></i>
      </li>
      <li v-for="(crumb, index) in crumbs">
        <router-link :to="{name: crumb.link, params: {id: crumb.id}}" tag="span" v-if="typeof crumb == 'object' && crumb.link != null"><a class="crumb">{{ crumb.name }}</a></router-link>
        <a v-else-if="crumb.url != null" :href="crumb.url" class="crumb">{{ crumb.name }}</a>
        <span v-else>{{ (typeof crumb == 'object') ? crumb.name : crumb }}</span>
        <i class="fa fa-angle-right" v-if="crumbs.length > ++index"></i>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  export default {
    props: ['crumbs'],
    computed: {
      ...mapGetters({
        user: 'getUser'
      })
    }
  }
</script>

<style scoped lang="scss">
.crumb {
  color: #d09f23;
  transition: color .3s;
  &:hover {
    color: #a77700;
  }
}
</style>



// WEBPACK FOOTER //
// Breadcrumbs.vue?4866fe32